import React, { useState, useRef, useCallback, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  Polygon,
  Marker,
  InfoWindow,
  Polyline,
} from "@react-google-maps/api";
import axios from "axios";
import { google } from "react-google-maps";
import {
  Checkbox,
  Col,
  Row,
  Popover,
  Image,
  Button,
  Form,
  Input,
  Modal,
  DatePicker,
} from "antd";
import { useHistory, useParams } from "react-router";
import ReactDOM from "react-dom";
import { authenticateToken } from "../../utils/auth";
import DriverMarker from "../../images/icon/DriverMarker.svg";
import { ConsoleSqlOutlined } from "@ant-design/icons";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import Empty from "../common/Empty";
import moment from "moment";
import CustomerLayout from "./Layout";
import CustomerHeader from "./Layout/topHeader";
import { responseNotification } from "../../utils/notify";
import { useSelector } from "react-redux";
const { RangePicker } = DatePicker;

const containerStyle = {
  width: "100%",
  height: "500px",
};

const DriverLocationHistoryMap = () => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(undefined);
  const [driverLocation, setDriverLocation] = useState([]);
  const [form] = Form.useForm();
  const [path, setPath] = useState([]);
  const [range, setRange] = useState({
    from: null,
    to: null,
  });
  const [getLocationHistory, setGetLocationHistory] = useState({
    loading: false,
    data: null,
  });
  const [activeMarker, setActiveMarker] = useState(null);
  const shopActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  const route = useParams();
  // new add

  const getDriverLocationHistory = useCallback(async () => {
    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();

    setGetLocationHistory({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    axios
      .get(
        `${encodedUri}/location/history?driverId=${route?.id}` +
          (from ? `&from=${from}` : ``) +
          (to ? `&to=${to}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            //Authorization: `Bearer eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI2MTk2NDRjNTBmYTYyNDdmN2QxZjA2ZmQiLCJpc3MiOiJBVVRIIiwibW9iaWxlTnVtYmVyIjoiKzg4MDE3MjM0NDM3NTEiLCJuYW1lIjoiTWQgQWJkdWwgR2FmdXIiLCJ0eXBlIjoiREVMSVZFUllfTUFOIiwiZXhwIjoxNjY0MzQ2NzA0fQ.sYXuumXp0kX7a0PD4PxUe1RM0O09jC0HI2L--sSGCvQ`,
          },
        }
      )
      .then((res) => {
        setPath(
          res.data?.locationHistories.map((point) => ({
            lat: point?.location?.latitude,
            lng: point?.location?.longitude,
          }))
        );

        setGetLocationHistory({ loading: false, data: res.data });
      })
      .catch((err) => {
        setGetLocationHistory({ loading: false, data: [] });
        console.error("Location: Error", err);
      });
  }, [range.from, range.to]);
  useEffect(() => {
    getDriverLocationHistory();
  }, [getDriverLocationHistory]);
  console.log("get all new path::", path);
  console.log(
    "Driver Location History get ::: ",
    getLocationHistory?.data?.locationHistories
  );
  // get polygon data
  const locationHistory = getLocationHistory[getLocationHistory.length - 1];
  console.log("loation position :", locationHistory);

  const position = {
    lat: locationHistory?.location?.latitude,
    lng: locationHistory?.location?.longitude,
  };

  const position2 = {
    lat: 23.773414356724892,
    lng: 90.41340705259854,
  };
  //new add order details map

  return (
    <>
      <CustomerLayout>
        <div className="bg-white">
          <CustomerHeader leftarea={"Location History"} />

          <div className="product-list-item-area white-bg section-padding-bottom">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-list-items-inner-content">
                    <div className="single-product-wrapper">
                      <Form form={form} className="search_form">
                        <Form.Item name="range">
                          <RangePicker
                            onChange={(e, f) => {
                              console.log(
                                "momnet",
                                moment(f[0])?.toISOString()
                              );
                              setRange({ from: f?.[0], to: f?.[1] });
                            }}
                            showTime={{
                              hideDisabledOptions: true,
                              defaultValue: [
                                moment("00:00:00", "HH:mm:ss"),
                                moment("23:59:59", "HH:mm:ss"),
                              ],
                            }}
                            inputReadOnly
                            allowClear
                          />
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <LoadScript
                  id="script-loader"
                  googleMapsApiKey="AIzaSyBAV5ux84Aast-onJ1DOq7uspbN6doNxXQ"
                  language="en"
                  region="us"
                >
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={
                      driverLocation?.location?.latitude ? position : position2
                    }
                    zoom={15}
                  >
                    <Polyline
                      options={{
                        strokeColor: "red",
                        strokeOpacity: 0.75,
                        strokeWeight: 4,
                        icons: [
                          {
                            // icon: lineSymbol,
                            offset: "0",
                            repeat: "20px",
                          },
                        ],
                      }}
                      path={
                        path
                      } /* All these coordinates are coming from props */
                    />

                    {getLocationHistory?.data?.locationHistories?.map(
                      (driverLocation) => (
                        <Marker
                          icon={DriverMarker}
                          title={moment(driverLocation?.createdAt).format(
                            "lll"
                          )}
                          position={{
                            lat: driverLocation?.location?.latitude,
                            lng: driverLocation?.location?.longitude,
                          }}
                          onClick={() => shopActiveMarker(driverLocation?.id)}
                        >
                          {activeMarker === driverLocation?.id ? (
                            <InfoWindow
                              onCloseClick={() => setActiveMarker(null)}
                            >
                              <div className="inner-body-wrapper">
                                <div className="inner-body">
                                  <div className="single">
                                    <div className="info-name">
                                      <span>Name</span>
                                    </div>
                                    <div className="info-desc">
                                      <span>{driverLocation?.user?.name}</span>
                                    </div>
                                  </div>
                                  <div className="single">
                                    <div className="info-name">
                                      <span>Mobile Number</span>
                                    </div>
                                    <div className="info-desc">
                                      <span>
                                        {driverLocation?.user?.mobileNumber}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="single">
                                    <div className="info-name">
                                      <span>Stay Time</span>
                                    </div>
                                    <div className="info-desc">
                                      <span>
                                        {moment(
                                          driverLocation?.createdAt
                                        ).format("lll")}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </InfoWindow>
                          ) : null}
                        </Marker>
                      )
                    )}
                  </GoogleMap>
                </LoadScript>
              </div>
            </div>
          </div>
        </div>
      </CustomerLayout>
    </>
  );
};

export default DriverLocationHistoryMap;
